import React from 'react';
import { MASTER_ALLERGY_EDIT_FIELDS } from './constant';
import { useDispatch } from 'react-redux';
import { Form, Formik } from 'formik';
import ModalComponent from '../../../../../components/common-components/modal/ModalComponent';
import Icons from '../../../../../components/icons/Icons';
import Button from '../../../../../components/common-components/button/Button';
import { BUTTON_VARIANTS } from '../../../../../components/common-components/button/Constants';
import Input from '../../../../../components/common-components/input/Input';
import { getValidationSchema } from '../../../../../libs/formsUtils';
import { updateMasterAllergy } from './MasterAllergySaga';

function MasterAllergyEditModel({data, open, close, }) {
    const dispatch = useDispatch();
    const fields = [
        {
            fieldName: MASTER_ALLERGY_EDIT_FIELDS.NAME,
            isRequired: true,
        },
        {
            fieldName: MASTER_ALLERGY_EDIT_FIELDS.CATEGORY,
            isRequired: true,
        },
        {
            fieldName: MASTER_ALLERGY_EDIT_FIELDS.REACTION,
            isRequired: true,
        },
        ];

    const validationSchema = getValidationSchema(fields)

    return (
        <Formik
            initialValues={
                {
                    [MASTER_ALLERGY_EDIT_FIELDS.NAME]: data?.name,
                    [MASTER_ALLERGY_EDIT_FIELDS.CATEGORY]: data?.category,
                    [MASTER_ALLERGY_EDIT_FIELDS.REACTION]: data?.reaction,

                }
            }
            validationSchema={validationSchema}
            enableReinitialize
            onSubmit={(values) => {
                const payload = {
                    apiPayload: {
                        ...values,
                    },
                    id: data?.uuid,
                    closeEditModal: close,
                    
                };                
                try {
                    dispatch(updateMasterAllergy(payload));
                } catch (err) {
                    console.log(err);
                }
            }}
        >
            {({ submitForm, isSubmitting, handleReset, values, setFieldValue, handleSubmit }) => {
                return (
                    <Form onSubmit={handleSubmit}>
                        <ModalComponent
                            open={open}
                            title={ 'Edit Allergy'}
                            close={() => {
                                close();
                            }}
                            icon={<Icons iconName="closeIcon" />}
                            footerButton={
                                <Button
                                    type="submit"
                                    variant={BUTTON_VARIANTS.CONTAINED}
                                    customBtnClass="text-met-primary"
                                >
                                    Save
                                </Button>
                            }
                            customClasses="w-[60%] overflow-visible"
                            enableReinitialize
                            hideOverflow={true}
                        >
                            <div className="flex flex-col">
                                <div className="w-full flex justify-between">
                                    <div className="w-[45%]">
                                        <Input
                                            label="Name"
                                            isRequired={true}
                                            placeholder="Enter Test Name"
                                            name={MASTER_ALLERGY_EDIT_FIELDS.NAME}
                                            value={values[MASTER_ALLERGY_EDIT_FIELDS.NAME]}
                                            onChangeCb={(e) => {
                                                setFieldValue(MASTER_ALLERGY_EDIT_FIELDS.NAME, e.target.value);
                                            }}
                                        />
                                    </div>
                                     <div className="w-[45%]">
                                        <Input
                                            label="Category"
                                            isRequired={true}
                                            placeholder="Enter Category Name"
                                            name={MASTER_ALLERGY_EDIT_FIELDS.CATEGORY}
                                            value={values[MASTER_ALLERGY_EDIT_FIELDS.CATEGORY]}
                                            onChangeCb={(e) => {
                                                setFieldValue(MASTER_ALLERGY_EDIT_FIELDS.CATEGORY, e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                                 <div className="w-full flex justify-between mt-[20px]">
                                    <div className="w-[45%]">
                                        <Input
                                            label="Reaction"
                                            isRequired={true}
                                            placeholder="Enter Reaction Name"
                                            name={MASTER_ALLERGY_EDIT_FIELDS.REACTION}
                                            value={values[MASTER_ALLERGY_EDIT_FIELDS.REACTION]}
                                            onChangeCb={(e) => {
                                                setFieldValue(MASTER_ALLERGY_EDIT_FIELDS.REACTION, e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </ModalComponent>
                    </Form>
                );
            }}
        </Formik>
    );
}

export default MasterAllergyEditModel;
